import { createVPhoneInput } from 'v-phone-input'
import 'flag-icons/css/flag-icons.min.css'
import 'v-phone-input/dist/v-phone-input.css'

export default function phoneInputPlugin () {
  return createVPhoneInput({
    countryIconMode:'svg',
    enableSearchingCountry: true,
    preferCountries: ['SA', 'JO', 'EGP', 'AE', 'QA'],
    defaultCountry: window.CURRENT_COUNTRY_ISO2,
  })
}
